import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import * as constants from '../../../utils/constants';

import toastService from '../../../services/toastService';

class AutPhotographicRecordForm extends Form {
	state = {
		data: { images: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialImages: PropTypes.array,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialImages && this.props.initialImages.length > 0) {
			this.setState({ data: { images: this.props.initialImages }});
		}
	}

	schema = {
		images: Joi.array().min(1).max(constants.IMAGE_LIMITS.GENERAL_PHOTOS).required().label('Photographic Record'),
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.images);
		toastService.success('Images saved successfully!')
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: constants.IMAGE_LIMITS.GENERAL_PHOTOS,
					multiple: constants.IMAGE_LIMITS.GENERAL_PHOTOS > 1,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'AUT Photographic Record',
					sublabel: 'Upload AUT Photographic Record',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default AutPhotographicRecordForm;
